import { getUserData } from "../../../global/hooks/getUserRole";
import { useEffect, useState } from "react";
import axios from "axios";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Col, Input, Modal, Row } from "antd";
import useGet from "../../../global/hooks/useGet";
import { OemColumns } from "./Columns";
import ConfirmModal from "../../../global/components/ConfirmModal";
import useDelete from "../../../global/hooks/useDelete";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import {
  DeleteOutlined,
  PlusOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";

const initialFilterState = { OemNo: "", Oem: "" };

export const Oem = () => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const [listData, setListData] = useState([]);
  const [params, setParams] = useSearchParams({
    limit: 10,
    sort_by: "OemNo",
    order: "desc",
  });
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const initialPagination = {
    current: parseInt(modParams.page) || 1,
    pageSize: parseInt(modParams.limit) || 10,
    total: 0,
  }; //
  const [pagination, setPagination] = useState(initialPagination);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filter, setFilter] = useState(initialFilterState);
  const [filterNoValueText, setFilterNoValueText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [unusedLoading, setUnusedLoading] = useState(false);
  const [showUnusedModal, setShowUnusedModal] = useState(false);
  const [unusedOems, setUnusedOems] = useState([]);

  const navigate = useNavigate();

  const breadcrumbItems = [
    {
      label: "OEM",
      href: "/oem",
    },
  ];

  // to get table data from API server
  const query = new URLSearchParams(params);
  // Remove unwanted keys
  query.delete("pageSize");
  query.delete("total");
  query.delete("current");
  const updatedQuery = query.toString();
  const url = updatedQuery
    ? `${process.env.REACT_APP_API_URL}/api/oems/?${updatedQuery}`
    : `${process.env.REACT_APP_API_URL}/api/oems/`;
  const { data, loading, error, refetch } = useGet(url);

  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/oems/bulk-delete/`;
  // selectedRowKeys.length > 1
  //   ? (deleteUrl = `${process.env.REACT_APP_API_URL}/api/oems/delete/`)
  //   : (deleteUrl = `${process.env.REACT_APP_API_URL}/api/oems/delete/${selectedRowKeys}/`);

  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    // deleteData,
    deleteMultiple,
  } = useDelete(deleteUrl);

  useEffect(() => {
    const matchedFilter = {};
    for (const key in initialFilterState) {
      if (modParams[key] !== undefined) {
        matchedFilter[key] = modParams[key];
      }
    }

    setFilter((prev) => ({
      ...prev,
      ...matchedFilter,
    }));
  }, []); //

  const paginationConfig = {
    current: pagination.current, //current page
    pageSize: pagination.pageSize, // items per page
    total: data?.count, // total items
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total, range) => `Total ${total} items ${range[0]}-${range[1]}`,
    onChange: (page, pageSize) => {
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
      });

      const updatedParams = {
        ...Object.fromEntries([...params.entries()]),
        limit: pageSize,
        page: page,
      };
      setParams(updatedParams);
    },
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    // navigate(`/oemlist/${newSelectedRowKeys}`);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };

  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {
        navigate(`/oem/info/${record?.OemNo}`);
      },
    };
  };

  const handleFilterChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value.replace(/['""`''""]/g, "");
    setFilter({ ...filter, [inputName]: inputValue });
  };

  const handleFilter = (e) => {
    const filterDict = {};
    for (const key in filter) {
      if (
        filter[key] !== null &&
        filter[key] !== "" &&
        filter[key] !== undefined
      ) {
        filterDict[key] = filter[key];
      }
    }
    const isEmpty = JSON.stringify(filterDict) === "{}";

    if (isEmpty) {
      setFilterNoValueText("No value exists!");
      handleReset();
    } else {
      const params = {
        limit: 10,
        sort_by: "OemNo",
        order: "desc",
        page: 1,
        ...filterDict,
      };
      setPagination((prev) => ({ ...prev, current: 1 }));
      setParams(params);
      refetch();
    }
  };

  // reset
  const handleReset = (e) => {
    // Reset the filter state to the initial state
    setFilter({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //
    // Define the new parameters for the API call
    const params = {
      limit: 10,
      sort_by: "OemNo", // Make sure to specify sorting if necessary
      order: "desc",
    };
    setParams(params);
    refetch();
  };

  const onDeleteConfirm = async () => {
    try {
      // if (selectedRowKeys.length === 1) {
      //   await deleteData();
      // } else {
      await deleteMultiple({ ids: selectedRowKeys });
      // }
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
    setSelectedRowKeys([]);
  };

  const handleDeleteUnused = async () => {
    setUnusedLoading(true);
    try {
      const token = getUserData();
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/oems/unused/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token?.access_token}`,
          },
        },
      );
      const payload = response?.data;
      const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
          ? payload.data
          : [];
      if (!list.length) {
        openErrorNotification("No unused OEMs found.");
        return;
      }
      setUnusedOems(list);
      setShowUnusedModal(true);
    } catch (error) {
      openErrorNotification(
        error?.response?.data?.message || "Something went wrong",
      );
    } finally {
      setUnusedLoading(false);
    }
  };

  const closeUnusedModal = () => {
    setShowUnusedModal(false);
    setUnusedOems([]);
  };

  const onUnusedDeleteConfirm = async () => {
    const ids = unusedOems
      .map((oem) => oem.OemNo)
      .filter((id) => id !== undefined && id !== null);
    if (!ids.length) {
      closeUnusedModal();
      return;
    }
    try {
      await deleteMultiple({ ids });
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    closeUnusedModal();
  };

  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      refetch();
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong",
      );
    }
  }, [deletedData, deletedDataError]);

  useEffect(() => {
    if (data && !loading) {
      // console.log("Before modifying", data?.data);
      const newData = data?.data?.map((oem) => ({
        ...oem,
        key: oem?.OemNo,
      }));
      // console.log("After modifying", newData);
      setListData(newData);
    }
  }, [data, loading]);

  // console.log(listData);
  return (
    <div>
      <div className="pb-4 -mt-4 pt-[6px]">
        <CommonBreadcrumb breadcrumbItems={breadcrumbItems} />
      </div>
      <div className="p-4 bg-white rounded-[4px] border border-gray-200">
        <div className="mb-4">
          <div className="mt-2">
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
                <Input
                  className="input_text_3 mr10 h-full"
                  name="OemNo"
                  placeholder="No"
                  value={filter.OemNo}
                  onChange={(e) => {
                    const { value } = e.target;
                    // Allow only positive integers or empty string
                    if (/^[1-9]\d*$/.test(value) || value === "") {
                      handleFilterChange(e);
                    }
                  }}
                  onKeyDown={(e) => {
                    // Prevent 'e', 'E', '+', '-' keys
                    const blockedKeys = ["e", "E", "+", "-", "."];
                    if (blockedKeys.includes(e.key)) {
                      e.preventDefault();
                    }
                    if (/^[0-9]$/.test(e.key)) {
                      const input = e.target;
                      const { selectionStart, selectionEnd, value } = input;
                      const nextValue =
                        value.slice(0, selectionStart) +
                        e.key +
                        value.slice(selectionEnd);

                      if (!/^(0|[1-9]\d*)$/.test(nextValue)) {
                        e.preventDefault();
                      }
                    }
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
                <Input
                  className="input_text_3 mr10 h-full"
                  name="Oem"
                  placeholder="Name"
                  value={filter.Oem}
                  onChange={handleFilterChange}
                />
              </Col>
            </Row>
          </div>
          <div className="w-full overflow-x-auto">
            <div className="flex justify-between mt-4 flex-nowrap min-w-[760px]">
              <div className="flex items-center">
                <Button
                  type="primary"
                  className="mr-2 w-[104px] h-[30px] font-medium"
                  onClick={handleFilter}
                >
                  <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
                  Apply
                </Button>
                <Button className="reset-button" onClick={handleReset}>
                  <HiArrowPath className="!text-[14px] font-medium" />
                  Reset
                </Button>
                <Button
                  type="primary"
                  className="mr-2 -ml-2 w-[104px] h-[30px] font-medium"
                  onClick={() => navigate("/oem/add")}
                >
                  <PlusOutlined />
                  Add
                </Button>
                <Button
                  type="primary"
                  disabled={selectedRowKeys?.length === 0 ? true : false}
                  className="mr-2 w-[104px] h-[30px] font-medium"
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  <DeleteOutlined />
                  Delete
                </Button>
                {/* <Button
                  type="primary"
                  className="mr-2 min-w-[104px] h-[30px] font-medium"
                  loading={unusedLoading}
                  onClick={handleDeleteUnused}
                >
                  <DeleteOutlined />
                  Delete Unused
                </Button> */}
              </div>
              {/* <div>
                <Button
                  type="primary"
                  className="mr-2 w-[30px] h-[30px]"
                  onClick={() => navigate("/oem/add")}
                >
                  <PlusOutlined />
                </Button>
                <Button
                  type="primary"
                  disabled={selectedRowKeys?.length === 0 ? true : false}
                  className="w-[30px] h-[30px]"
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  <DeleteOutlined />
                </Button>
              </div> */}
            </div>
          </div>
        </div>
        <ConfirmModal
          showModal={showModal}
          setShowModal={setShowModal}
          onDeleteConfirm={onDeleteConfirm}
          setSelectedRowKeys={setSelectedRowKeys}
        />
        <Modal
          open={showUnusedModal}
          onCancel={closeUnusedModal}
          closable={false}
          width={420}
          centered
          footer={null}
        >
          <div className="flex pt-4 pb-2 flex-col font-['Poppins'] w-full">
            <div className="flex items-start gap-x-4 w-full px-4">
              <span className="flex items-center justify-center w-10 h-10 bg-yellow-100 text-yellow-600 rounded-full flex-shrink-0 mt-0.5">
                <WarningOutlined className="text-2xl" />
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-[15px] font-medium leading-6 text-black m-0">
                  Are you sure you want to Delete {unusedOems.length} unused oem
                  {unusedOems.length === 1 ? "" : "s"}?
                </p>
                <p className="text-[13px] leading-5 text-[#5b6b7a] mt-1.5 mb-0">
                  These OEMs are not associated with any device and will be
                  permanently deleted.
                </p>
              </div>
            </div>

            <div className="mt-3 mx-4 rounded-md border border-[#e5e7eb] overflow-hidden">
              <div className="max-h-[240px] overflow-y-auto">
                <div className="grid grid-cols-[64px_1fr] gap-x-2 px-2.5 py-1.5 bg-[#f4f5f9] text-[11px] font-medium text-[#6b7280] sticky top-0 z-10">
                  <span>No</span>
                  <span>Name</span>
                </div>
                {unusedOems.map((oem) => (
                  <div
                    key={oem.OemNo}
                    className="grid grid-cols-[64px_1fr] gap-x-2 px-2.5 py-1.5 text-[13px] text-black border-t border-[#eef0f3]"
                  >
                    <span className="text-[#374151]">{oem.OemNo}</span>
                    <span className="truncate">
                      {oem.OemName || oem.Oem || "—"}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex justify-end space-x-3 mt-4 w-full px-1">
              <button
                onClick={onUnusedDeleteConfirm}
                className="px-6 py-1 text-[14px] bg-[#007BFF] text-white rounded-md hover:bg-white hover:text-[#007BFF] transition shadow-none hover:shadow-[0_4px_12px_rgba(0,0,0,0.25)]"
              >
                Yes
              </button>
              <button
                onClick={closeUnusedModal}
                className="px-6 py-1 text-[14px] text-white bg-red-600 rounded-md hover:bg-white hover:text-red-600 transition shadow-none hover:shadow-[0_4px_12px_rgba(0,0,0,0.25)]"
              >
                No
              </button>
            </div>
          </div>
        </Modal>
        <GlobalTable
          columns={OemColumns(
            hoveredRow,
            setShowModal,
            setSelectedRowKeys,
            setParams,
            params,
          )}
          dataSource={listData}
          rowSelection={rowSelection}
          pagination={paginationConfig}
          onRow={(record, rowIndex) => {
            return {
              onMouseEnter: () => setHoveredRow(rowIndex),
              onMouseLeave: () => setHoveredRow(null),
              ...onRow?.(record, rowIndex),
            };
          }}
          loading={loading}
        />
      </div>
    </div>
  );
};
